// ** React Imports
import { useState, useEffect, SyntheticEvent, useRef } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
    CardHeader,
    CardContent,
} from '@mui/material'
import { useParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import appInfo from '../../../../configs/app-info';
import { useToast } from '../../../../components/ToastProvider';

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();
    const inputRef = useRef<HTMLInputElement>(null)

    // ** State
    const [noDokumen, setNoDokumen] = useState<any>(null)
    const [qty, setQty] = useState<any>(null)

    const [listData, setListData] = useState<any[]>([])
    const [valueTabs, setValueTabs] = useState<string>('0')


    useEffect(() => {
        if (valueTabs === '1') {
            setTimeout(() => inputRef.current?.focus(), 100)
        }
    }, [valueTabs])

    const handleChangeTab = (event: SyntheticEvent, newValue: string) => {
        setValueTabs(newValue)
    }

    const cekBatchScan = (batchId: any) => {
        console.log(batchId);
    }

    const masukkanNik = async () => {
        const { value: nik, isConfirmed } = await Swal.fire({
            title: 'Masukkan NIK',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Batal',
            showLoaderOnConfirm: true,
            preConfirm: nikVal => {
                if (!nikVal) {
                    Swal.showValidationMessage('NIK tidak boleh kosong')
                } else {
                    return nikVal
                }
            }
        })

        if (!isConfirmed || !nik) return

        // siapkan opsi gudang. Jika localStorage 'cabang' berisi list, pakai itu.
        let inputOptions: Record<string, string> = {}
        try {
            if (Array.isArray(cabang)) {
                cabang.forEach((g: any, idx: number) => {
                    const key = g.id ?? g.kode ?? `gudang_${idx}`
                    const label = g.nama ?? g.name ?? g.kode ?? key
                    inputOptions[key] = label
                })
            } else if (cabang && (cabang.nama || cabang.name || cabang.id || cabang.kode)) {
                const key = cabang.id ?? cabang.kode ?? 'gudang_0'
                const label = cabang.nama ?? cabang.name ?? key
                inputOptions[key] = label
            } else {
                // fallback contoh opsi; ganti dengan panggilan API jika perlu
                inputOptions = {
                    GUDANG_A: 'Gudang A',
                    GUDANG_B: 'Gudang B'
                }
            }
        } catch (e) {
            inputOptions = {
                GUDANG_A: 'Gudang A',
                GUDANG_B: 'Gudang B'
            }
        }

        const { value: gudang, isConfirmed: gudangConfirmed } = await Swal.fire({
            title: 'Pilih Gudang',
            input: 'select',
            inputOptions,
            inputPlaceholder: 'Pilih gudang',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Batal',
            preConfirm: val => {
                if (!val) {
                    Swal.showValidationMessage('Pilih gudang terlebih dahulu')
                } else {
                    return val
                }
            }
        })

        if (gudangConfirmed && gudang) {
            // lanjutkan proses dengan nik dan gudang yang dipilih
            console.log('NIK:', nik, 'Gudang:', gudang)
            // contoh: setNoDokumen, setQty, panggil API dsb.
        }
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h4' sx={{ textAlign: 'center' }}>
                        Detail Usage Kain
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        Quantity : <b>{qty}</b>
                    </Typography>
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant='contained' color='primary' size='large' sx={{ width: '300px' }} onClick={masukkanNik}>
                                Mulai Usage
                            </Button>
                        </Box>
                    </CardContent>
                    <Divider />
                    <CardContent>
                        <TabContext value={valueTabs}>
                            <TabList scrollButtons variant='scrollable' onChange={handleChangeTab}>
                                <Tab value='1' label='BAHAN BAKU' />
                                <Tab value='2' label='BAHAN JADI' />
                            </TabList>
                            <TabPanel value='1'>
                                <Box sx={{ mb: 4 }}>
                                    <TextField
                                        fullWidth
                                        type='number'
                                        label='ID Batch'
                                        variant='outlined'
                                        inputRef={inputRef} // gunakan inputRef, bukan ref (MUI TextField tidak meneruskan ref ke input)
                                        onKeyDown={e => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault()
                                                const input = e.target as HTMLInputElement
                                                cekBatchScan(input.value)
                                                if (inputRef.current) {
                                                    inputRef.current.value = ''
                                                    inputRef.current.focus()
                                                }
                                            }
                                        }}
                                    />
                                </Box>
                                <MsiDatagrid array={listData} />
                            </TabPanel>
                            <TabPanel value='2'>
                                <MsiDatagrid array={listData} />
                            </TabPanel>
                        </TabContext>
                    </CardContent>
                </div>
            </Grid>
        </Grid >
    )
}
